// extracted by mini-css-extract-plugin
export default {"container":"CMobilePlanList_container__BTFUe","planList":"CMobilePlanList_planList__n4Afb","planItem":"CMobilePlanList_planItem__egjuS","cButton":"CMobilePlanList_cButton__9IllE"};